import { render, staticRenderFns } from "./Effects.vue?vue&type=template&id=3dafe1be&scoped=true&"
import script from "./Effects.vue?vue&type=script&lang=ts&"
export * from "./Effects.vue?vue&type=script&lang=ts&"
import style0 from "./Effects.vue?vue&type=style&index=0&id=3dafe1be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dafe1be",
  null
  
)

export default component.exports